import { IFeeSection } from '../organizeFees';
import { currencyFields, eFeePropertyNames } from '../../../../types/order/fees/eFeePropertyNames';

export interface ITableColumn {
  label: string;
  value: (...t: { [key: string]: any }[]) => any;
  isVisible?: boolean;
}

export const refiNameChange = (name: string, isRefinance: boolean) => {
  if (!isRefinance) return name;
  switch (name) {
    case eFeePropertyNames.BuyerPaid:
      return eFeePropertyNames.BorrowerPaid;
    case eFeePropertyNames.BuyerPaidAtClosing:
      return eFeePropertyNames.BorrowerPaidAtClosing;
    case eFeePropertyNames.BuyerPaidBeforeClosing:
      return eFeePropertyNames.BorrowerPaidBeforeClosing;
    default:
      return name;
  }
};

const sellerProperties: string[] = [
  eFeePropertyNames.SellerPaid,
  eFeePropertyNames.SellerPaidAtClosing,
  eFeePropertyNames.SellerPaidBeforeClosing,
];

// Sometimes we have a field, like amount. that doesn't really mean amount. It means one of a number of things.
// This let's us make a structure and pattern for the application that will allow this and not require hardcoding things.
// For this column, we want the first one with a value.
const relatedFields = {
  [eFeePropertyNames.Amount]: currencyFields,
};

const ignoredProperties: string[] = [eFeePropertyNames.HiddenTotals];

const baseColumnsToShow = [
  eFeePropertyNames.Name,
  eFeePropertyNames.Payee,
  eFeePropertyNames.Status,
  eFeePropertyNames.BuyerPaidAtClosing,
  eFeePropertyNames.BuyerPaidBeforeClosing,
  eFeePropertyNames.SellerPaidAtClosing,
  eFeePropertyNames.SellerPaidBeforeClosing,
  eFeePropertyNames.OthersPaid,
  eFeePropertyNames.NettedOut,
];

export const getColumns = (feeSection: IFeeSection, isRefinance: boolean): ITableColumn[] => {
  const totalNames = feeSection.sectionDefinition.sectionPropertyTotalNames;
  let tableColumns = totalNames.filter(
    (property) => !((sellerProperties.includes(property) && isRefinance) || ignoredProperties.includes(property))
  );
  const columnsToShow = baseColumnsToShow.filter((t) => !(sellerProperties.includes(t) && isRefinance));
  const mainPageOfFees = tableColumns.reduce(
    (total, current) => total && columnsToShow.includes(current as eFeePropertyNames),
    true
  );

  return mainPageOfFees
    ? columnsToShow.map((t) => createColumn(t, isRefinance, tableColumns))
    : tableColumns.map((t) => createColumn(t as eFeePropertyNames, isRefinance));
};

const createColumn = (propertyName: eFeePropertyNames, isRefinance: boolean, tableColumns?: string[]) => ({
  label: refiNameChange(propertyName, isRefinance),
  value: (...t: { [key: string]: any }[]) => {
    if (!!relatedFields[propertyName]) {
      const fieldWithRelatedFields: eFeePropertyNames[] = relatedFields[propertyName];
      return fieldWithRelatedFields.reduce(
        (p, c) => (p === undefined ? (t.find((item) => item[c]) || {})[c] : p),
        undefined as number | undefined
      );
    } else {
      return (t.find((item) => item[propertyName]) || {})[propertyName];
    }
  },
  isVisible: tableColumns?.includes(propertyName),
});
